import MathHtml from 'components/imported-assessment/MathHtml'
import update from 'immutability-helper'
import {zip} from 'lodash'
import clsx from 'clsx'
import React from 'react'
import {makeStyles} from 'external/material'
import Box from '@mui/material/Box'
import MenuItem from '@mui/material/MenuItem'
import Select from '@mui/material/Select'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableContainer from '@mui/material/TableContainer'
import TableRow from '@mui/material/TableRow'
import Table from '@mui/material/Table'

const useStyles = makeStyles(matchingStyles)

export default function Matching ({context, section, question, questionIndex}) {

  const classes = useStyles()
  const {translate, quizAssessmentToTake: assessment, assessment: assessmentId, saveAnswers} = context

  const answer = assessment.answers[question.id] || {}

  async function handleChange(term, definition) {

    const selected = update(answer.selected, {
        [answer.selected.indexOf(definition)]: {$set: -1},
        [term]: {$set: definition},
    })

    const completed = selected.find(i => i == -1) == undefined

    const {quizAssessmentToTake: assessment} = await context.updateState({quizAssessmentToTake: {
      answers: { [question.id]: {
        completed: {$set: completed},        
        selected: {$set: selected}
    }}}})
    context.saveAnswers({id: assessmentId, answers: assessment.answers})
  }

  const terms = answer.terms.map(({term}, index) => {

    return (<React.Fragment>
      <TableCell className={clsx(classes.cell, classes.selectAnswer)} size="small">
        <SelectDefinition
          index={index}
          definitions={answer.definitions}
          onChange={handleChange}
          value={answer.selected[index]}
        />
      </TableCell>
      {context.importedMath ? <TableCell className={clsx(classes.cell, classes.termHtml)}><MathHtml html={term || ''} /></TableCell> : <TableCell className={clsx(classes.cell, classes.termHtml)} dangerouslySetInnerHTML={{__html: term || ''}} />}
    </React.Fragment>)
  })

  const definitions = answer.definitions.map(({definition}, index) => {
    const answerIndex = String.fromCharCode(Math.min(index, 20) + 97)
    return (<React.Fragment>
      <TableCell className={clsx(classes.cell, classes.definitionIndex, {selected: answer.selected.indexOf(index) > -1})} size="small">
        {answerIndex})
      </TableCell>
      {context.importedMath ? <TableCell className={clsx(classes.cell, classes.definitionValue)}><MathHtml html={definition || ''} /></TableCell> : <TableCell className={clsx(classes.cell, classes.definitionValue)} dangerouslySetInnerHTML={{__html: definition || ''}} />}
    </React.Fragment>)
  })

  return (
  <Box className={classes.root}>
    <TableContainer component={Box} className={classes.tableContainer}>
      <Table className={classes.table}>
        <TableBody>{
          zip(terms, definitions).map(([term, definition], index) => {
            return (
              <TableRow key={index} className={classes.pair}>
                {term}
                {definition}
              </TableRow>
            )
          })}</TableBody>
     </Table>
   </TableContainer>
  </Box>
  )
}

function SelectDefinition (props) {

  const classes = useStyles()

  function handleChange (e) {
    props.onChange(props.index, e.target.value)
  }

  return (
    <Select
      className={classes.termValue}
      value={props.value}
      onChange={handleChange}
    >
      <MenuItem style={{display: 'none'}} value={-1}> </MenuItem>
      {props.definitions.map((definition, index) => {
        const answerIndex = String.fromCharCode(Math.min(index, 20) + 97)
        return (
          <MenuItem key={index} value={index}>{answerIndex}</MenuItem>
        )
      })}
    </Select>
  )
}

function matchingStyles (theme) {
  return {
    root: {
      display: 'flex',
      marginTop: 10,
      flexGrow: 1
    },
    tableContainer: {
      flexShrink: 0,
      maxWidth: 1280,
      display: 'flex',
      fontSize: '12pt',
    },
    cell: {
      borderBottom: 0,
      padding: '16px 8px',
      verticalAlign: 'top'
    },
    correctAnswer: {
      width: 35,
      flexGrow: 0,
      flexShrink: 0,
      maxWidth: 35
    },
    selectAnswer: {
      width: 45,
      flexGrow: 0,
      flexShrink: 0,
      maxWidth: 45,
    },
    definitionIndex: {
      width: 20,
      flexGrow: 0,
      flexShrink: 0,
      maxWidth: 20
    },
    termValue: {
      border: 'solid 1px #e0e5e9',
      borderRadius: 3,
      paddingLeft: 8,
      justifyContent: 'center',
      '&:focus': {
        backgroundColor: 'transparent'
      },
      '&:before' : {
        borderBottom: '0 !important'
      },
      '&:after': {
        borderBottom: 0
      }
    },
    termHtml: {
      paddingLeft: 20,
      '& > p': {
        margin: 0
      }
    },
    definitionValue: {
      paddingLeft: 20,
      '& > p': {
        margin: 0
      }
    }
  }
}
